<div class="privacy-page-shell">
<article class="privacy-page">
  <header class="privacy-page__header">
    <h1 class="privacy-page__title">Privacy Policy</h1>
    <p class="privacy-page__meta">Last updated: {{ lastUpdated }}</p>
    <p>
      This Privacy Policy describes how VectorNote (&ldquo;we&rdquo;, &ldquo;us&rdquo;, or &ldquo;our&rdquo;) handles
      information when you use our mobile applications. It applies to:
    </p>
    <ul class="privacy-page__apps">
      <li>VectorNote Tripmeter</li>
      <li>VectorNote Roadbook</li>
    </ul>
  </header>

  <section>
    <h2>1. Overview</h2>
    <p>
      VectorNote Tripmeter and VectorNote Roadbook are tools designed for rally and motorsport navigation.
      Both apps may access your device location and other sensors to measure distance, speed, and orientation
      while you use them. We are committed to explaining clearly what data is used and why.
    </p>
  </section>

  <section>
    <h2>2. Location and geolocation data</h2>
    <p>
      <strong>Both applications access location data from your device (GPS / geolocation).</strong>
      This is required for core functionality. Depending on your device, permissions, and app settings,
      location may be accessed while the app is in the foreground and, if you grant the appropriate permissions,
      while the app is in the background (for example, when the screen is locked during a stage).
    </p>

    <h3>VectorNote Tripmeter</h3>
    <p>Location data is used to:</p>
    <ul>
      <li>Calculate the distance travelled during your trip</li>
      <li>Display your current speed (km/h)</li>
      <li>Determine your direction of travel when using GPS-based orientation (&ldquo;By Location&rdquo; mode)</li>
    </ul>
    <p>
      When the vehicle is stationary, the app may keep the last known orientation and indicate that GPS-based
      orientation calculation is paused until movement resumes.
    </p>

    <h3>VectorNote Roadbook</h3>
    <p>Location data is used to:</p>
    <ul>
      <li>Calculate the distance travelled during your trip</li>
      <li>Display your current speed (km/h)</li>
      <li>Determine your direction of travel when using GPS-based orientation</li>
      <li>Support navigation features related to your position along the route</li>
    </ul>

    <p>
      Location data is processed on your device to provide real-time trip information. We do
      <strong>not</strong> sell your location data to third parties and we do <strong>not</strong> use your
      location for advertising purposes.
    </p>
    <p>
      You can revoke location access at any time in your device settings. Without location permission,
      distance tracking and GPS-based orientation will not work correctly.
    </p>
  </section>

  <section>
    <h2>3. Motion and sensor data</h2>
    <p>
      If you enable sensor-based orientation in either app, the device motion sensors (such as the compass /
      magnetometer) may be used to display heading. This data is processed on your device and is not sold
      to third parties.
    </p>
  </section>

  <section>
    <h2>4. Data stored on your device</h2>
    <p>
      Both apps may store trip-related settings and state locally on your device (for example, distance decimals,
      orientation preferences, or recovered trip state) so that your experience continues between sessions.
      This information remains on your device unless you uninstall the app or reset app data.
    </p>
  </section>

  <section>
    <h2>5. Account and cloud data (VectorNote Roadbook)</h2>
    <p>
      VectorNote Roadbook may allow you to sign in and access roadbooks or related content through our services.
      In that case, account and content data necessary to provide those features may be processed through our
      backend infrastructure (including Firebase). We use this information only to operate the service you request,
      such as authentication, content delivery, and account management.
    </p>
    <p>
      VectorNote Tripmeter does not require an account for its core tripmeter functionality.
    </p>
  </section>

  <section>
    <h2>6. Data we do not collect for advertising</h2>
    <p>
      We do not use the apps to build advertising profiles, and we do not sell personal data to data brokers.
    </p>
  </section>

  <section>
    <h2>7. Data retention</h2>
    <p>
      Data stored locally on your device remains until you delete it, reset the app, or uninstall the application.
      Account-related data associated with VectorNote Roadbook is retained as long as needed to provide the service
      and as required by applicable law.
    </p>
  </section>

  <section>
    <h2>8. Children&rsquo;s privacy</h2>
    <p>
      Our applications are not directed at children under 13, and we do not knowingly collect personal information
      from children.
    </p>
  </section>

  <section>
    <h2>9. Changes to this policy</h2>
    <p>
      We may update this Privacy Policy from time to time. The &ldquo;Last updated&rdquo; date at the top of this
      page will reflect the latest version. Continued use of the apps after changes are published constitutes
      acceptance of the updated policy.
    </p>
  </section>

  <section>
    <h2>10. Contact</h2>
    <p>
      If you have questions about this Privacy Policy or about how location data is used in our apps, please
      contact us through <a href="https://vectornote.com" target="_blank" rel="noopener noreferrer">vectornote.com</a>.
    </p>
  </section>
</article>
</div>
